import { AnimalTry, AnimalMoveAtlas, AnimalTools, ReversiMultiFlip, ConnectFinish, ConnectTurns, TwixtWin, TwixtDistances, TwixtCrossing } from './NextRuleDiagrams';
import type { GameId } from '../wasm';
import { AbalonePush, AbaloneMoving, AbaloneStrength, AmazonsBlocked, AmazonsSteps, GomokuFirstThree, GomokuOpening, KyoenShapes, StoneLine } from './RuleDiagrams';

function AbalonePaper() {
  return <article className="rule-paper rule-paper--abalone">
    <section><h2>相手の玉を6個、盤の外へ押し出すと<span style={{whiteSpace:'nowrap'}}>勝ちです。</span></h2><figure><AbalonePush /></figure></section>
    <section><h2>隣り合って一直線に並ぶ自分の玉を<br />1〜3個まとめて1マス動かします。</h2><figure><AbaloneMoving /></figure></section>
    <section><h2>列に沿って、動かす玉より少ない数の<br />相手の玉を押せます。</h2><figure><AbaloneStrength /></figure></section>
  </article>;
}
function AmazonsPaper() {
  return <article className="rule-paper rule-paper--amazons">
    <section><h2>相手の4コマをすべて動けなくすると<span style={{whiteSpace:'nowrap'}}>勝ちです。</span></h2><figure><AmazonsBlocked /></figure></section>
    <section><h2>自分のコマを1個動かし、<br />移動先から矢を撃ちます。</h2><figure><AmazonsSteps /></figure><p className="rule-small">コマも矢も縦・横・斜めの空いたマスへ<span style={{whiteSpace:'nowrap'}}>何マスでも進めます。</span></p><p className="rule-small">コマや矢を飛び越せません。</p><p className="rule-small">撃った矢はずっと残ります。</p></section>
  </article>;
}
function GomokuPaper() {
  return <article className="rule-paper rule-paper--gomoku">
    <section><h2>自分の石を縦・横・斜めに<br />ちょうど5個並べると<span style={{whiteSpace:'nowrap'}}>勝ちです。</span></h2><figure><StoneLine comparison /></figure><figure><StoneLine comparison count={6} label="5つより多く並んだ場合は続行です。" /></figure></section>
    <section><h2>最初に置く人（仮先）が<br />3個置きます。</h2><figure><GomokuFirstThree /></figure><h2 className="gomoku-choice-heading">もう一人（仮後）は<br />次のどちらかを選びます。</h2><figure><GomokuOpening /></figure></section>
  </article>;
}
function KyoenPaper() {
  return <article className="rule-paper rule-paper--kyoen">
    <section><h2>同じ円周か一直線上に並ぶ4個の石を見つけて知らせると<span style={{whiteSpace:'nowrap'}}>勝ちです。</span></h2><figure><KyoenShapes /><figcaption>直前に相手が置いた石を含めます。</figcaption></figure></section>
    <section><p className="rule-small">二人で同じ石を使い、交互に1個ずつ置きます。</p><p className="rule-small">自分の番に4個選んで宣言します。選択途中でも宣言できますが、誤った宣言は負けです。</p></section>
  </article>;
}

function AnimalPaper() {
 return <article className="rule-paper rule-paper--animal">
 <section><h2>相手のライオンを取れば<span className="next-unbroken">勝ちです。</span></h2><p className="rule-small">自分のライオンを相手側の一番奥の段へ進めても<span className="next-unbroken">勝ちです。</span></p><figure><AnimalTry /></figure></section>
 <section><p className="rule-small">交互に自分の駒を1枚動かすか、持ち駒を1枚<span className="next-unbroken">置きます。</span></p><AnimalMoveAtlas /></section>
 <section className="animal-tools-section"><figure><AnimalTools /></figure><p className="rule-small">取った駒は自分の持ち駒になり、空いたマスに<span className="next-unbroken">置けます。</span>取ったにわとりはひよこに戻ります。</p><p className="rule-small">ひよこを相手側の一番奥の段へ進めると、にわとりになります。</p></section>
 </article>;
}
function ReversiPaper() {
 return <article className="rule-paper rule-paper--reversi">
 <section><h2>ゲーム終了時に、石が多い方の<span className="next-unbroken">勝ちです。</span></h2><figure className="rules-count"><div><span className="stone stone--black" />黒 <b>34</b></div><div><span className="stone stone--white" />白 <b>30</b></div></figure></section>
 <section><h2>自分の石で相手の石を挟める空きマスに、石を置きます。</h2><figure><ReversiMultiFlip /><figcaption>縦・横・斜めのどの方向でも挟めます。</figcaption></figure><p className="rule-small">挟んだ相手の石はすべて裏返ります。</p></section>
 <div className="rules-ending rule-small"><p>交互に石を1個ずつ置きます。置けるマスがなければパスします。</p><p>二人とも石を置けなくなると終わります。石の数が同じなら引き分けです。</p></div>
 </article>;
}
function ConnectPaper() {
 return <article className="rule-paper rule-paper--connect6">
 <section><h2>自分の石を縦・横・斜めに6個以上並べると<span className="next-unbroken">勝ちです。</span></h2><figure><ConnectFinish /></figure></section>
 <section><h2>初手は黒が石を1個置きます。以後は白と黒が交互に2個ずつ<span className="next-unbroken">置きます。</span></h2><figure><ConnectTurns /></figure><p className="rule-small">1個目を置いて6個以上並べば、その時点で<span className="next-unbroken">勝ちです。</span></p></section>
 </article>;
}
function TwixtPaper() {
 return <article className="rule-paper rule-paper--twixt">
 <section><h2>黒は上下の辺を、白は左右の辺を、自分の駒と橋でつなぐと<span className="next-unbroken">勝ちです。</span></h2><figure><TwixtWin /></figure></section>
 <section><h2>交互に空いている穴に自分の駒を1つずつ<span className="next-unbroken">置きます。</span></h2><figure><TwixtDistances /></figure><p className="rule-small">1:2で離れた同じ色の駒に橋をかけます。</p></section>
 <section><figure><TwixtCrossing /></figure><p className="rule-small">相手の橋と交差する橋はかかりませんが、駒は<span className="next-unbroken">置けます。</span></p><p className="rule-small">相手側の2辺の境界線より外側にある穴には<span className="next-unbroken">置けません。</span></p></section>
 </article>;
}

export function OtherRulePaper({ game }: { game: GameId }) {
  switch (game) {
    case 'AnimalShogi': return <AnimalPaper />;
    case 'Reversi': return <ReversiPaper />;
    case 'Connect6': return <ConnectPaper />;
    case 'TwixT': return <TwixtPaper />;
    case 'Abalone': return <AbalonePaper />;
    case 'Amazons': return <AmazonsPaper />;
    case 'Gomoku': return <GomokuPaper />;
    case 'Kyoen': return <KyoenPaper />;
    default: return null;
  }
}
